module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("浙江龙井区块链溯源节点")]), _vm._v(" "), _c('ul', [(_vm.list.length != 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "swiper-slide"
    }, [_c('p', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.node))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("区块链编号")]), _c('span', [_vm._v(_vm._s(item.id))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("操作人")]), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (item.note.length) ? _c('p', [_c('span', [_vm._v(_vm._s(item.note))]), _c('span', [_vm._v(_vm._s(item.note1))])]) : _vm._e()])
  }), 0) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3849bd9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/chaye/components/center/centerBottom/index.vue
// module id = 1979
// module chunks = 2